$(document).ready(function(){
	pageInit();

	$('a.scroll').click(function(event){
		event.preventDefault();
		var $target = $(this).attr('href');
		$('html, body').animate({
	        scrollTop: $($target).offset().top - 30
	    }, 500);
	});

	//Age Verify
	if( Cookies.get('age_verification') == 'accepted' ) {

	} else {
		$('#verify').removeClass('hidden');
	}
	$('#verify_accept').click(function(e){
		e.preventDefault();
		$('#verify').addClass('hidden');
		Cookies.set('age_verification', 'accepted', { expires: 1 });
	});
	$('#verify_cancel').click(function(e){
		e.preventDefault();
		parent.history.back();
	});
})

$(window).scroll(function(){
	//Check Sroll Pos for logo on homepage
	logoScroll();
})

$(window).load(function(){
	//Hide Loading Screen
	$('#loading').addClass('hide-me');
})

function pageInit(){
	//Check Sroll Pos for logo on homepage
	logoScroll();
}

function logoScroll() {
	if( $(document).scrollTop() > ($(window).height()/2) ) {
		$('.will-scroll').addClass('show');
	} else {
		$('.will-scroll').removeClass('show');
	}
}